import type { CompletedShipmentConfirmation } from '../../../core/api/shipment/models/completed-shipment.model';

/**
 * Returns true when the completed shipment has a scheduled courier pickup (OM-890).
 * Matches ESN’s “pickup selected” cancel-copy gate using confirmation number and PRESCHEDULED type.
 */
export function hasAssociatedPickup(
  confirmation: CompletedShipmentConfirmation | null | undefined,
): boolean {
  if (!confirmation) {
    return false;
  }

  if (confirmation.pickupConfirmationNumber?.trim()) {
    return true;
  }

  const info = confirmation.shipmentInformation;
  if (info?.pickupType === 'PRESCHEDULED') {
    return true;
  }

  return Boolean(info?.pickup?.confirmationNumber?.trim());
}
